import { IdentifierDefinition } from '.';

export const channel: IdentifierDefinition = {
  id: 'channel',
  apiId: 'channels',
  queryId: 'channel',
  paramsId: 'channel',
  publicId: 'channel',
};
export const channelEdition: IdentifierDefinition = {
  id: 'edition',
  apiId: 'editions',
  queryId: 'edition',
  paramsId: 'edition',
  publicId: 'edition',
};
export const channelEditionPlaylist: IdentifierDefinition = {
  id: 'playlist',
  apiId: 'playlists',
  queryId: 'playlist',
  paramsId: 'playlist',
  publicId: 'playlist',
};

export const identifiers: IdentifierDefinition[] = [
  channel,
  channelEdition,
  channelEditionPlaylist,
];
